import React from 'react';
import { Link } from 'react-router-dom';


const DealCard = ({ lead }) => {
    return (
        <div className='lead-card'>
            <div className='row'>
                <div className='col-12 col-md-12 lead-image position-relative'>
                    {lead?.deal_image ? (
                        <img src={lead?.deal_image} className='img-fluid' alt={lead?.deal_property_title} title={lead?.deal_property_title || lead?.name} />
                    ) : (
                        <img src="/images/landscape-placeholder.svg" alt="placeholder" className='img-fluid' title={lead?.deal_property_title || lead?.name} />
                    )}

                    <Link to={`/invest-now?deal=${lead?.name || lead?.deal_property_title}`} className='btn btn-primary sin-button px-4 py-2 rounded-pill shadow-sm btn-invest-now position-absolute' style={{ right: '25px', bottom: '10px', border: '2px solid #ffffff' }} title={lead?.deal_property_title || lead?.name}>Invest Now</Link>
                </div>
                <div className='col-12 col-md-12'>
                    <div className='lead-info'>
                        <div className='row'>
                            <div className='col-12 col-md-12'>
                                <h3 className='lead-title' title={lead?.deal_property_title || lead?.name}>{lead?.deal_property_title || lead?.name}</h3>
                            </div>
                            <div className='col-12 col-md-12 mb-2'>
                                <div className='row'>
                                    <div className='col-6 text-center border-end'>
                                        <div className='price-text mb-1'>Reserved Price</div>
                                        <h2 className='price-amount mb-0'> {lead?.reserve_price || " - "}</h2>
                                    </div>
                                    <div className='col-6 text-center'>
                                        <div className='price-text mb-1'>Market Value</div>
                                        <h2 className='price-amount mb-0 '> {lead?.approx_market_value + ' *' || " - "}</h2>
                                    </div>
                                </div>
                            </div>
                            <div className='col-12 col-md-12 mb-0'>
                                <p className='mb-0 auction-text text-center text-red fw-bold'>
                                    Auction Date - <span >{lead?.bid_date_auction_date || " - "}</span>
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className='lead-info-bottom bg-gradient-linear'>
                        <div className='row'>
                            <div className='col-12 col-md-12 mb-0 d-flex position-relative'>
                                <img src="/images/basil_location-outline.svg" alt="loc" className='location-icon' onError={(e) => e.target.style.display = 'none'} />
                                <p className='mb-0 address-text' title={lead?.location}>
                                    {lead?.location || " - "}
                                </p>
                            </div>
                            <div className='col-12 col-md-12 text-center mb-3 mt-2'>
                                {/* <h6 className='text-muted fw-bold mb-2 features-title'>PROPERTY FEATURES</h6> */}
                                <div className='row g-0 rounded-3 overflow-hidden features-box'>
                                    <div className='col-4 py-2 px-2 border-end border-white-50'>
                                        <div className='small feature-label'>AREA</div>
                                        <div className='fw-bold feature-value area-value'>{lead?.area || " - "}</div>
                                    </div>
                                    <div className='col-4 py-2 px-2 border-end border-white-50'>
                                        <div className='small feature-label'>DISCOUNT PRICE</div>
                                        <div className='fw-bold feature-value'>{lead?.discount || " - "}</div>
                                    </div>
                                    <div className='col-4 py-2 px-2'>
                                        <div className='small feature-label'>CBP SERVICE CHARGE</div>
                                        <div className='fw-bold feature-value'>{lead?.cbp_service_charge || " - "}</div>
                                    </div>
                                </div>
                                <p className='mt-2 fst-italic text-start disclaimer-text mb-0'>*Maintenance, Property Tax And Electricity Dues Are Additional.</p>
                            </div>
                            {/* <div className='col-12 col-md-12 mb-3 d-flex justify-content-center'>
                                <Link to={`/signup?deal=${lead.name}`} className='btn btn-primary sin-button px-4 py-2 rounded-pill shadow-sm btn-invest-now'>Invest Now</Link>
                            </div> */}
                        </div>
                    </div>
                </div>
            </div>
        </div >
    );
};

export default DealCard;
